import { HardSkillEntry } from 'utils/cv-form-db/types';
import { usePaginatedQuery } from '../../hooks';
import { useHardSkillsInfiniteQuery } from './query';
import { isHardSkillsComplete } from './utils';

export const useHardSkillsForm = (values: HardSkillEntry) => {
  return {
    isComplete: isHardSkillsComplete(values)
  };
};

export const useHardSkillsNames = () => {
  const infiniteQuery = useHardSkillsInfiniteQuery();
  return usePaginatedQuery(infiniteQuery, 'hardSkills');
};
